import { getPositions } from '@/apis/objectManage'
import { ref, unref } from 'vue'
import {
  columnUseSceneEnums,
  dealFormConfig,
  isMapping,
  isQuote
} from '@/utils/preObjectManage/utils'
import { fieldTypeConfig, moduleType, operateListEnum } from '@/enums/preObjectManage'
import { formulaCalculation } from '@/utils/business/formulaCalculation'
import { getFieldFormulaConfig } from '@/utils/business/formulaEmitter'
import { cloneDeep } from '@/utils/tools'
import { isString } from '@/utils/is'
import { QuoteMapping } from '@/utils/render/quoteMapping'
import { getValueByMenu } from '@/router/utils'
import { getAllRoleFieldList } from '@/apis/permissionManage'
import EventEmitter from '@/utils/event'

const visibleEmitter = new EventEmitter()
const equationEmitter = new EventEmitter()
const referralPersonEmitter = new EventEmitter()
const associaFormEmitter = new EventEmitter()

export function useForm(props: Recordable) {
  console.log('新式神', props)

  const select = ref(0)
  const formData = ref<Recordable>({})
  if (props.formData) {
    formData.value = unref(props.formData)
  }
  // 布局字段
  const positions = ref<Recordable[]>([])
  const positionInfo = ref<Recordable>({})
  const tableInfo = ref<Recordable>({})
  // 字段的显隐
  const visibleBox = ref<Recordable[]>([])
  // 布局的显隐
  const layoutVisibleBox = ref<Recordable[]>([])
  // 引用映射类
  const quoteMappingConfig = new QuoteMapping()
  // 所有按钮数据
  const allBtnListData = ref<Recordable[]>([])

  // 定义一个公式计算的数据存储map
  const mapData: Recordable = {}

  // 配置了公式的字段容器
  const equationList = ref<Recordable[]>([])

  const allAuthField = ref<Recordable[]>([])

  // 关联表单条件容器
  const associaFormCondition = ref<Recordable[]>([])
  // 获取布局
  function getFormLayout(fn?: Fn) {
    Promise.all([
      getAllRoleFieldList({ appCode: props.tableCode }),
      getPositions({
        tableCode: props.tableCode,
        type: 0,
        customerReq: { orderType: props.orderType }
      })
    ]).then(([res1, res2]) => {
      allAuthField.value = res1 || []
      if (res2?.buttonList?.length) {
        res2.buttonList.forEach((item: { visibleList: any[]; show: boolean }) => {
          if (item.visibleList) {
            const current = item.visibleList.find(sub => sub.actionSerial === '2')
            item.show = !current
          } else {
            item.show = true
          }
        })
      }
      allBtnListData.value = res2?.buttonList || []
      positions.value = dealAuth(res2.positions || [], res1 || [])
      positionInfo.value = res2.positionInfo
      tableInfo.value = res2.tableInfo
      const layout = unref(positionInfo)?.layout
        ? JSON.parse(unref(positionInfo).layout)
        : { select: 1 }
      select.value = layout.select || 1
      fn && fn()
      initForm()
    })
  }

  // 处理权限范围内的字段显示
  function dealAuth(positions: Recordable[], authList: Recordable[]) {
    positions.forEach(container => {
      if (container.code === 'BLANK') {
        container.modules.forEach((module: Recordable) => {
          module.componentList = module.componentList.filter((field: Recordable) => {
            const authField = authList.find(
              authField => authField.fieldSerial === field.columnInfo.fieldSerial
            )
            return authField && authField.viewFlag
          })
        })
      }
      if (container.code === 'TABLE') {
        container.children.forEach((child: Recordable) => {
          child.modules.forEach((module: Recordable) => {
            module.componentList = module.componentList.filter((field: Recordable) => {
              const authField = authList.find(
                authField => authField.fieldSerial === field.columnInfo.fieldSerial
              )
              return authField && authField.viewFlag
            })
          })
        })
      }
    })
    return positions
  }

  // 判断有没有字段的编辑权限
  function dealAuthEdit(fieldSerial: string) {
    if (fieldSerial === '4f2251af6f094ab1b0f93084ea27fde8') return false
    const authField = allAuthField.value.find(authField => authField.fieldSerial === fieldSerial)
    return authField && authField.editFlag
  }

  // 初始化表单
  function initForm() {
    const cloneData = cloneDeep([...unref(positions)])
    cloneData.sort((a: any, b: any) => {
      const layoutA = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
      const positionA = layoutA.position
      const layoutB = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
      const positionB = layoutB.position
      return positionA?.x - positionB?.x
    })
    // positions.value
    const newArr = cloneData.map((container: Recordable) => {
      if (container.code === 'BLANK') {
        container.modules = container.modules.map((module: Recordable) => {
          // 取出moduleSerial相同的按钮存起来
          const btnArr = allBtnListData.value.filter(
            btn => btn.moduleSerial === module.moduleSerial
          )
          module.buttonList = btnArr.sort((a, b) => a.sort - b.sort)
          // 排序
          module.componentList.sort((a: any, b: any) => {
            const layoutX = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
            const positionX = layoutX.position
            const layoutY = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
            const positionY = layoutY.position
            // 首先按照 x 从小到大排序
            if (positionX?.x !== positionY?.x) {
              return positionX?.x - positionY?.x
            }
            // 如果 x 相同，则按照 y 从小到大排序
            return positionX?.y - positionY?.y
          })
          module.componentList = module.componentList.map((field: Recordable) => {
            const {
              code,
              fieldCode,
              fieldType,
              visibleRuleList,
              defaultMark,
              defaultValue,
              id,
              _columnConfig,
              _precisions,
              setting,
              fieldSerial
            } = field.columnInfo
            const settingData = getFieldFormulaConfig(setting)

            if (settingData.web.equation) {
              equationList.value.push(field)
            }
            // 取出下拉单选和单选按钮的显隐规则
            if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
              // 如果设置的显隐规则，就需要注册监听事件
              if (visibleRuleList && visibleRuleList.length) {
                visibleRuleList.forEach((item: Recordable<any>) => {
                  if (item.actionCode === 'COLUMN') {
                    visibleBox.value.push({
                      ...item,
                      show: defaultValue === item.value
                    })
                  } else if (item.actionCode === 'LAYOUT') {
                    layoutVisibleBox.value.push({
                      ...item,
                      show: defaultValue === item.value
                    })
                  }
                })
              }
            }

            // if (code === fieldTypeConfig.percentage) {
            //   field.columnInfo.minValue = !isNullOrUndefOrEmpty(field.columnInfo.minValue) ? field.columnInfo.minValue : 1
            //   field.columnInfo.maxValue = !isNullOrUndefOrEmpty(field.columnInfo.maxValue) ? field.columnInfo.maxValue : 100
            // }

            field.layout = JSON.parse(field.layout)
            // 处理值的时候，如果有默认值要取默认值
            if (defaultMark === 0) {
              // 自定义
              // 兼容以序列号作为formData的key
              formData.value[fieldCode] =
                formData.value[fieldSerial] ||
                formData.value[fieldCode] ||
                getValueByMenu(id) ||
                defaultValue ||
                ''
            } else {
              // 兼容以序列号作为formData的key
              formData.value[fieldCode] =
                formData.value[fieldSerial] || formData.value[fieldCode] || ''
            }

            let customCode = code
            // 引用字段
            if (isQuote(fieldType)) {
              customCode = fieldTypeConfig.quote
            }
            // 映射字段
            if (isMapping(fieldType)) {
              customCode = fieldTypeConfig.mapping
            }
            // 只处理部分组件采用关联已有数据组件
            // 产品说都只取单条了
            // if (defaultMark === 1 && !associatedDataExclude.includes(code)) {
            //   customCode = fieldTypeConfig.associatedData
            // }
            const strategyFn =
              dealFormConfig[customCode] || dealFormConfig[fieldTypeConfig.singleLineText] // 默认值为单行文本
            console.log(module.moduleType, 'module.moduleType', field)
            const renderConfig = strategyFn(
              { ...field, ...field.columnInfo },
              {
                tableColumnType: module.moduleType
              },
              quoteMappingConfig
            )
            // 处理该字段在新增布局中是否置灰
            renderConfig.disabled = !dealAuthEdit(fieldSerial) || !addEditDisabled(field) || false

            // 给每个字段绑定一个显隐的事件
            renderConfig.visibleEmitter = visibleEmitter
            // 给每个字段绑定一个公式计算的事件
            renderConfig.equationEmitter = equationEmitter
            let useSceneType = 3
            if (
              code === fieldTypeConfig.person ||
              code === fieldTypeConfig.personMultiple ||
              code === fieldTypeConfig.department ||
              code === fieldTypeConfig.multipleDepartment
            ) {
              if (
                code === fieldTypeConfig.personMultiple &&
                ['4f2251af6f094ab1b0f93084ea27fde8'].includes(field.columnInfo?.fieldSerial)
              ) {
                // 协助人字段特殊处理
                useSceneType = 6
              } else {
                useSceneType = 5
              }

              // if (precisions === 1 && columnConfig) {
              //   useSceneType = 5
              // } else if (precisions === 2 || precisions === 3) {
              //   const settingData = setting ? !isEmpty(JSON.parse(setting)) ? JSON.parse(setting) : { web: {} } : { web: {} }
              //   if (settingData.web.depFieldSerial) {
              //     useSceneType = 5
              //   }
              // }
            }
            if (
              code === fieldTypeConfig.referralPersonSource ||
              code === fieldTypeConfig.referralPerson
            ) {
              renderConfig.referralPersonEmitter = referralPersonEmitter
            }
            return {
              ...field,
              ...field.columnInfo,
              renderConfig,
              columnUseScene: columnUseSceneEnums.addPage,
              useSceneType: useSceneType
            }
          })

          // 处理关联表单的条件
          if (module.moduleType === moduleType.subForm) {
            // associaFormCondition
            const conditionInfo = module.conditionInfo
            if (conditionInfo && conditionInfo?.conditionList) {
              const columnSerials: string[] = []
              conditionInfo.conditionList.forEach((condition: { conditions: any[] }) => {
                condition.conditions.forEach(condi => {
                  if (condi.rightType === 10) {
                    columnSerials.push(condi.rightColumnSerial)
                  }
                })
              })
              associaFormCondition.value.push({
                moduleSerial: module.moduleSerial,
                Emitter: associaFormEmitter,
                columnSerials
              })
            }
          }
          return {
            ...module,
            visibleEmitter, // 控制分栏，子表，关联表单的显隐
            associaFormEmitter // 控制关联表单条件查询
          }
        })
      }
      if (container.code === 'TABLE') {
        container.children.sort((a: any, b: any) => {
          const layoutA = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
          const positionA = layoutA.position
          const layoutB = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
          const positionB = layoutB.position
          return positionA?.x - positionB?.x
        })
        container.children = container.children.map((child: Recordable) => {
          child.modules = child.modules.map((module: Recordable) => {
            // 取出moduleSerial相同的按钮存起来
            const btnArr = allBtnListData.value.filter(
              btn => btn.moduleSerial === module.moduleSerial
            )
            module.buttonList = btnArr.sort((a, b) => a.sort - b.sort)
            // 排序
            module.componentList.sort((a: any, b: any) => {
              const layoutX = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
              const positionX = layoutX.position
              const layoutY = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
              const positionY = layoutY.position
              // 首先按照 x 从小到大排序
              if (positionX?.x !== positionY?.x) {
                return positionX?.x - positionY?.x
              }
              // 如果 x 相同，则按照 y 从小到大排序
              return positionX?.y - positionY?.y
            })
            module.componentList = module.componentList.map((field: Recordable) => {
              const {
                code,
                fieldCode,
                fieldType,
                visibleRuleList,
                defaultMark,
                defaultValue,
                _columnConfig,
                _precisions,
                setting,
                fieldSerial
              } = field.columnInfo
              const settingData = getFieldFormulaConfig(setting)

              if (settingData.web.equation) {
                equationList.value.push(field)
              }

              // 取出下拉单选和单选按钮的显隐规则
              if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
                // 如果设置的显隐规则，就需要注册监听事件
                if (visibleRuleList && visibleRuleList.length) {
                  visibleRuleList.forEach((item: Recordable<any>) => {
                    if (item.actionCode === 'COLUMN') {
                      visibleBox.value.push({
                        ...item,
                        show: defaultValue === item.value
                      })
                    } else if (item.actionCode === 'LAYOUT') {
                      layoutVisibleBox.value.push({
                        ...item,
                        show: defaultValue === item.value
                      })
                    }
                  })
                }
              }
              // if (code === fieldTypeConfig.percentage) {
              //   field.columnInfo.minValue = !isNullOrUndefOrEmpty(field.columnInfo.minValue) ? field.columnInfo.minValue : 1
              //   field.columnInfo.maxValue = !isNullOrUndefOrEmpty(field.columnInfo.maxValue) ? field.columnInfo.maxValue : 100
              // }
              field.layout = JSON.parse(field.layout)
              console.log(defaultMark, 'defaultMark2')
              // 处理值的时候，如果有默认值要取默认值
              if (defaultMark === 0) {
                // 自定义
                // 兼容以序列号作为formData的key
                formData.value[fieldCode] =
                  formData.value[fieldSerial] || formData.value[fieldCode] || defaultValue || ''
              } else {
                // 兼容以序列号作为formData的key
                formData.value[fieldCode] =
                  formData.value[fieldSerial] || formData.value[fieldCode] || ''
              }
              let customCode = code
              // 引用字段
              if (isQuote(fieldType)) {
                customCode = fieldTypeConfig.quote
              }
              // 映射字段
              if (isMapping(fieldType)) {
                customCode = fieldTypeConfig.mapping
              }
              // if (defaultMark === 1) {
              //   customCode = fieldTypeConfig.associatedData
              // }
              // 默认值为单行文本
              const strategyFn =
                dealFormConfig[customCode] || dealFormConfig[fieldTypeConfig.singleLineText]
              const renderConfig = strategyFn(
                { ...field, ...field.columnInfo },
                {
                  tableColumnType: module.moduleType
                },
                quoteMappingConfig
              )

              // 处理该字段在新增布局中是否置灰
              renderConfig.disabled = !dealAuthEdit(fieldSerial) || !addEditDisabled(field) || false
              // 给每个字段绑定一个显隐的事件
              renderConfig.visibleEmitter = visibleEmitter
              // 给每个字段绑定一个公式计算的事件
              renderConfig.equationEmitter = equationEmitter
              let useSceneType = 3
              if (
                code === fieldTypeConfig.person ||
                code === fieldTypeConfig.personMultiple ||
                code === fieldTypeConfig.department ||
                code === fieldTypeConfig.multipleDepartment
              ) {
                useSceneType = 5
                // if (precisions === 1 && columnConfig) {
                //   useSceneType = 5
                // } else if (precisions === 2 || precisions === 3) {
                //   const settingData = setting ? !isEmpty(JSON.parse(setting)) ? JSON.parse(setting) : { web: {} } : { web: {} }
                //   if (settingData.web.depFieldSerial) {
                //     useSceneType = 5
                //   }
                // }
              }
              return {
                ...field,
                ...field.columnInfo,
                renderConfig,
                columnUseScene: columnUseSceneEnums.addPage,
                useSceneType: useSceneType
              }
            })

            // 处理关联表单的条件
            if (module.moduleType === moduleType.subForm) {
              // associaFormCondition
              const conditionInfo = module.conditionInfo
              if (conditionInfo && conditionInfo?.conditionList) {
                const columnSerials: string[] = []
                conditionInfo.conditionList.forEach((condition: { conditions: any[] }) => {
                  condition.conditions.forEach(condi => {
                    if (condi.rightType === 10) {
                      columnSerials.push(condi.rightColumnSerial)
                    }
                  })
                })
                associaFormCondition.value.push({
                  moduleSerial: module.moduleSerial,
                  Emitter: associaFormEmitter,
                  columnSerials
                })
              }
            }
            return {
              ...module,
              visibleEmitter, // 控制分栏，子表，关联表单的显隐
              associaFormEmitter // 控制关联表单条件查询
            }
          })
          console.log(child, 'child99')
          return {
            ...child
          }
        })
      }
      return {
        ...container
      }
    })
    // newArrCopy.value = newArr
    positions.value = newArr
    dealVisible()
  }

  // 处理显隐规则字段显示问题和公式计算
  function dealVisible() {
    const showLayout: string[] = []
    const showField: string[] = []
    // 跟进显隐规则隐藏对应的字段
    positions.value.forEach(container => {
      if (container.code === 'BLANK') {
        container.modules.forEach((module: Recordable) => {
          let layoutFlag = false
          layoutVisibleBox.value.forEach(visible => {
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1 && visible.show) {
              const cur = showLayout.find(showItem => showItem === module.moduleSerial)
              if (!cur) {
                showLayout.push(module.moduleSerial)
              }
            }
          })
          layoutFlag = layoutVisibleBox.value.every(visible => {
            const flag = true
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1) {
              return false
            }
            return flag
          })

          module.visibleEmitter.on(`addVisible_${module.moduleSerial}`, (show: boolean) => {
            module.show = show
          })
          module.show = showLayout.includes(module.moduleSerial) || layoutFlag
          module.componentList.forEach((field: Recordable) => {
            let fieldFlag = false
            visibleBox.value.forEach(visible => {
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1 && visible.show) {
                const cur = showField.find(showItem => showItem === field.fieldSerial)
                if (!cur) {
                  showField.push(field.fieldSerial)
                }
              }
            })
            fieldFlag = visibleBox.value.every(visible => {
              const flag = true
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1) {
                return false
              }
              return flag
            })
            field.renderConfig.visibleEmitter.on(
              `addVisible_${field.fieldSerial}`,
              (show: boolean) => {
                // 隐藏字段后要在计算中去掉
                if (!show) {
                  delete mapData[field.fieldSerial]
                }
                field.show = show
              }
            )
            field.show = showField.includes(field.fieldSerial) || fieldFlag

            // 处理计算公式
            if (field.defaultMark === 2) {
              formulaCalculation(module, field, formData, mapData)
            }
          })
        })
      }
      if (container.code === 'TABLE') {
        container.children.forEach((child: Recordable) => {
          child.modules.forEach((module: Recordable) => {
            let layoutFlag = false
            layoutVisibleBox.value.forEach(visible => {
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(module.moduleSerial) !== -1 && visible.show) {
                const cur = showLayout.find(showItem => showItem === module.moduleSerial)
                if (!cur) {
                  showLayout.push(module.moduleSerial)
                }
              }
            })
            layoutFlag = layoutVisibleBox.value.every(visible => {
              const flag = true
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(module.moduleSerial) !== -1) {
                return false
              }
              return flag
            })

            module.visibleEmitter.on(`addVisible_${module.moduleSerial}`, (show: boolean) => {
              module.show = show
            })
            module.show = showLayout.includes(module.moduleSerial) || layoutFlag

            module.componentList.forEach((field: Recordable) => {
              let fieldFlag = false
              visibleBox.value.forEach(visible => {
                const actionSerial = visible.actionSerial.split(',')
                if (actionSerial.indexOf(field.fieldSerial) !== -1 && visible.show) {
                  const cur = showField.find(showItem => showItem === field.fieldSerial)
                  if (!cur) {
                    showField.push(field.fieldSerial)
                  }
                }
              })
              fieldFlag = visibleBox.value.every(visible => {
                const flag = true
                const actionSerial = visible.actionSerial.split(',')
                if (actionSerial.indexOf(field.fieldSerial) !== -1) {
                  return false
                }
                return flag
              })
              field.renderConfig.visibleEmitter.on(
                `addVisible_${field.fieldSerial}`,
                (show: boolean) => {
                  // 隐藏字段后要在计算中去掉
                  if (!show) {
                    delete mapData[field.fieldSerial]
                  }
                  field.show = show
                }
              )
              field.show = showField.includes(field.fieldSerial) || fieldFlag
              // 处理计算公式
              if (field.defaultMark === 2) {
                formulaCalculation(module, field, formData, mapData)
              }
            })
          })
        })
      }
    })
    console.log(positions.value, 'positions.value2344')
    // positions.value = copyData
    // console.log(newArrCopy, 'newArrCopy44')
  }

  // 新增布局该字段是否置灰
  function addEditDisabled(field: Recordable) {
    const current = field.columnInfo.columnOperateList.find((operate: Recordable) => {
      return operate.value && operate.code === operateListEnum.ADD_PAGE_EDIT
    })
    return !!current
  }
  return {
    initForm,
    getFormLayout,
    formData,
    select,
    positions,
    quoteMappingConfig,
    visibleBox,
    layoutVisibleBox,
    allBtnListData,
    equationList,
    tableInfo,
    associaFormCondition
  }
}
